import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import Link from '@material-ui/core/Link';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const useStyles = makeStyles((theme) => ({
  privacyPolicyControlLabel: {
    marginTop: 24,
  },
  privacyPolicyControlLabelText: {
    fontSize: '0.9rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.7rem',
    },
  },
  checkbox: {
    alignSelf: 'flex-start',
    marginTop: -9,
  },
}));

const PrivacyPolicyControl = ({ checked, onChange }) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      classes={{
        root: classes.privacyPolicyControlLabel,
        label: classes.privacyPolicyControlLabelText,
      }}
      control={
        <Checkbox
          checked={checked}
          onChange={() => onChange(!checked)}
          color="primary"
          className={classes.checkbox}
        />
      }
      label={
        <span>
          {t('pdfDialog.privacyPolicyTextBefore')}{' '}
          <Link href={t('footer.links.dataPrivacy.link')} target="_blank">
            {t('pdfDialog.privacyPolicyLinkText')}
          </Link>{' '}
          {t('pdfDialog.privacyPolicyTextAfter')}
        </span>
      }
    />
  );
};

PrivacyPolicyControl.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PrivacyPolicyControl;
